module.exports = __webpack_public_path__ + "img/unionpay.099cb667.svg";